// import { API_URL } from "../../config";
// import axios from 'axios'
import { generatePopup } from '../../utils/popup'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { Action } from '../actionTypes'

export const planPayment: any = (payload: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    const functions = getFunctions()
    const processPayment = httpsCallable(functions, 'processPayment')

    dispatch({
      type: Action.USER_PAYMENT_INIT,
    })
    processPayment(payload)
      .then((res: any) => {
        let response = res.data || {}
        if (response) {
          if (response.error){
            dispatch({
              type: Action.USER_PAYMENT_FAIL,
              payload: [],
              message: response.message,
              error: response.error,
            })
            generatePopup('error', response?.message)
          } else {
            console.log("res++", res);
            dispatch({
              type: Action.USER_PAYMENT_SUCCESS,
              payload: [],
              message: "payment was successful",
              error: false,
            })
            // generatePopup('success', response?.message)
          }
        } else{
          dispatch({
            type: Action.USER_PAYMENT_FAIL,
            payload: [],
            message: "Error Processing Payment",
            error: true,
          })
          response["message"] = "Error Processing Payment"
          response["error"] = true
        }
        resolve(response)
      })
      .catch((error: any) => {
        if (error) {
          dispatch({
            type: Action.USER_PAYMENT_FAIL,
            payload: [],
            error: error,
          })
          generatePopup('error', 'Server request failed. Try again later.')
        }
        resolve('Server request failed. Try again later.')
      })
  })
}

export const cartPayment: any = (payload: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    const functions = getFunctions()
    const processCart = httpsCallable(functions, 'processCart')
    dispatch({ type: Action.USER_PAYMENT_INIT })

    processCart(payload)
      .then((res: any) => {
        let response = res.data || {}
        if (response) {
          if (response.error){
            dispatch({ type: Action.USER_PAYMENT_FAIL, payload: [], message: response.message, error: response.error, })
            generatePopup('error', response?.message)
          } else {
            console.log("res++", res);
            dispatch({ type: Action.USER_PAYMENT_SUCCESS, payload: [], message: "payment was successful", error: false,})
            generatePopup('success', response?.message)
          }
        } else{
          dispatch({ type: Action.USER_PAYMENT_FAIL, payload: [], message: "Error Processing Payment", error: true, })
          response["message"] = "Error Processing Payment"
          response["error"] = true
        }
        resolve(response)
      })
      .catch((error: any) => {
        if (error) {
          dispatch({ type: Action.USER_PAYMENT_FAIL, payload: [], error: error, })
          generatePopup('error', 'Server request failed. Try again later.')
        }
        resolve('Server request failed. Try again later.')
      })
  })
}
